import Numeral from 'numeral';
import Svg_Icon from 'root/module/svg_icon';
import Constants from 'root/constants';
import Cache from 'root/cache';
import View from 'view/base';

export default View.extend({
    initialize: function(options) {
        this.data = options.data;

        this.listenTo(Cache.statistics, 'change:project_count', this.render);
    },

    render: function() {
        var portal = Cache.portal.findWhere({project_id: Cache.default_project_id});

        var project_overview  = Cache.statistics.get('project_count') ? Cache.statistics.get('project_count')[Cache.default_project_id] : false;
        var total_impressions = project_overview ? project_overview['impressions'] : 0;

        var project_key = Cache.getDefaultProject().get('project_key');

        var content =
        '<div class="feedback-widget-impressions font-weight-medium">Impressions: ' + Numeral(total_impressions).format('0,0') + '</div>' +
        '<div class="feedback-type-count box box-nopadding grid-4-4-4">' +
            '<a class="navigation no-underline" href="/' + project_key + '/feedback/?type=' + Constants.FEEDBACK_BUG + '">' +
                '<h4>Bugs</h4>' +
                '<div class="flex-start">' +
                    '<div class="feedback-type-icon">' + Svg_Icon.feedback_bug + '</div>' +
                    (this.data ?
                    '<div class="figure">' + Numeral(this.data.feedback_type.bug).format('0,0') + '</div>' :
                    '<div class="loader-placeholder" style="width:50px;"></div>') +
                '</div>' +
            '</a>' +
            '<a class="navigation no-underline gradient-line-left" href="/' + project_key + '/feedback/?type=' + Constants.FEEDBACK_FEATURE_REQUEST + '">' +
                '<h4>Ideas</h4>' +
                '<div class="flex-start">' +
                    '<div class="feedback-type-icon">' + Svg_Icon.feedback_feature_request + '</div>' +
                    (this.data ?
                    '<div class="figure position-relative">' +
                        Numeral(this.data.feedback_type.feature_request).format('0,0') +
                        (portal ?
                        '<div class="pending-count badge-small badge-primary-invert">' +
                            'Portal: ' + this.data.portal_overview.in_portal +
                        '</div>' : '') +
                    '</div>' :
                    '<div class="loader-placeholder" style="width:50px;"></div>') +
                '</div>' +
            '</a>' +
            '<a class="navigation no-underline gradient-line-left" href="/' + project_key + '/feedback/?type=' + Constants.FEEDBACK_GENERAL + '">' +
                '<h4>General</h4>' +
                '<div class="flex-start">' +
                    '<div class="feedback-type-icon">' + Svg_Icon.feedback_general + '</div>' +
                    (this.data ?
                    '<div class="figure">' + Numeral(this.data.feedback_type.general).format('0,0') + '</div>' :
                    '<div class="loader-placeholder" style="width:50px;"></div>') +
                '</div>' +
            '</a>' +
        '</div>';

        this.$el.html(content);

        return this;
    }
});